<template>
  <div class="pay-result-component">
    <div class="result-content">
      <div class="result-top">
        <p>{{status}}</p>
        <p class="bank-error" v-html="bankResult"></p>
        <div>
          <span @click="goBackCenter">返回个人主页</span>
          <span @click="goOrder">去我的订单</span>
        </div>
      </div>
      <div class="qr-module">
        <p>您可以使用微信家长端约课了！</p>
        <p>微信扫描二维码</p>
        <img src="@/assets/images/order/result-qr.jpg" />
        <img
          v-for="(o, i) in qrImg"
          :key="i"
          :src="o.paidBackUrl"
        />
      </div>
    </div>
    <eggs-dialog
      :visible.sync="eggsDialogVisible"
      :url="eggsBg"
      from="payResult"
    ></eggs-dialog>
  </div>
</template>

<script>
import eggsDialog from '../components/eggsDialog.vue'

export default {
  components: {
    eggsDialog
  },
  data() {
    return {
      orderId: '',
      status: '',
      eggsDialogVisible: false,
      eggsBg: '',
      qrImg: [],
      checkPayStatus: null,
      apiTimes: 0,
      type: this.$route.query.type,
      payStatus: this.$route.query.payStatus,
      bankResult: this.$route.query.bankResult ? decodeURI(this.$route.query.bankResult) : ''
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    this.getOrderStatus()
  },
  methods: {
    getOrderStatus() {
      this.axios({
        method: 'post',
        url: '/gw/order-rest/api/order_rest/pay/paid/status',
        params: {
          payOrderId: this.orderId,
          _timeStamp: new Date().getTime()
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.qrImg = Array.isArray(res.data.data.paidBackImageList) ? res.data.data.paidBackImageList : []

          // 境外支付时，判断返回的参数，失败的话直接进行状态展示
          if (this.type === 'abroad' && this.payStatus !== 'SUCCESS' && this.payStatus) {
            this.status = '支付失败'
            return
          }

          // 砸金蛋
          if (!res.data.data.isShouldShowEgg) {
            this.axios({
              method: 'get',
              url: '/activity/api/activity/advPosition/getPositionInfoByCode',
              params: {
                code: 'banner_pc_paid_popup'
              }
            }).then(res => {
              if (res.data.code === 200) {
                this.eggsBg = res.data.data[0].imageUrl
                this.eggsDialogVisible = true

              }
              this.status = '支付成功'
            })
          } else if (res.data.data.status == 'PAY_CONFIRMED' || res.data.data.status == 'PAID') {
            this.status = '支付成功'
          } else {
            this.checkStatusApi()
            this.status = '支付中'
          }
        } else {
          this.status = '支付失败'
        }
      }).catch(err => {
        this.status = '订单参数异常'
      })
    },
    goBackCenter() {
      window.location.href = window.origin + '/parent/home'
    },
    goOrder() {
      this.$router.push({
        path: '/order/list'
      })
    },
    checkStatusApi() {
      this.checkPayStatus = setInterval(() => {
        if (this.apiTimes > 5) {
          clearInterval(this.checkPayStatus)
          this.status = '支付失败'
          return
        }
        ++this.apiTimes
        this.axios({
          method: 'post',
          url: '/gw/order-rest/api/order_rest/pay/paid/status',
          params: {
            payOrderId: this.orderId,
            _timeStamp: new Date().getTime()
          }
        }).then(response => {
          let res = response.data
          if (res.code === 200) {
            if (res.data.status == 'PAY_CONFIRMED' || res.data.status == 'PAID') {
              clearInterval(this.checkPayStatus)
            }
          }
        })
      }, 5000)
    }
  },
  beforeDestroy() {
    clearInterval(this.checkPayStatus)
  }
}

</script>

<style lang="less" scoped>
.pay-result-component {
  .result-content {
    width: 310px;
    margin: 40px auto 60px;
    border: 1px solid #f65d21;
    text-align: center;
    border-radius: 10px;
    overflow: hidden;
    line-height: 1;
    .result-top {
      padding: 50px 0 20px;
      background-color: #f65d21;
      p {
        font-size: 36px;
        font-weight: 700;
        color: #fff;
        &.bank-error {
          display: inline-block;
          margin-top: 5px;
          font-size: 14px;
        }
      }
      div {
        margin: 20px 0;
        span {
          display: inline-block;
          cursor: pointer;
          color: #fff;
          margin: 0 10px;
          text-decoration: underline;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
    .qr-module {
      padding: 10px 0;
      p {
        color: #555;
        &:nth-of-type(1) {
          margin: 20px 0;
          font-size: 16px;
        }
        &:nth-of-type(2) {
          margin: 0;
          font-size: 22px;
          font-weight: 400;
        }
      }
      img {
        margin: 10px auto 0;
        height: 160px;
        width: 160px;
      }
    }
  }
}
</style>
